import { Routes } from '@angular/router';

export const formQuestionOptionTypesRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/form-question-option-types/form-question-option-types.component').then(c => c.FormQuestionOptionTypesComponent),
    data: { pageTitle: 'PAGES.FORM_QUESTION_OPTION_TYPES.TITLE', pageType: 'list', isAnonymous: true }
  },
  {
    path: 'add',
    loadComponent: () => import('./pages/add-edit-form-question-option-type/add-edit-form-question-option-type.component').then(c => c.AddEditFormQuestionOptionTypeComponent),
    data: { pageTitle: 'PAGES.FORM_QUESTION_OPTION_TYPES.ADD', pageType: 'add', isAnonymous: true }
  },
  {
    path: 'edit/:id',
    loadComponent: () => import('./pages/add-edit-form-question-option-type/add-edit-form-question-option-type.component').then(c => c.AddEditFormQuestionOptionTypeComponent),
    data: { pageTitle: 'PAGES.FORM_QUESTION_OPTION_TYPES.EDIT', pageType: 'edit', isAnonymous: true }
  },
  {
    path: 'view/:id/add-question',
    loadComponent: () => import('./pages/add-option-type-question/add-option-type-question.component').then(c => c.AddOptionTypeQuestionComponent),
    data: { pageTitle: 'PAGES.FORM_QUESTION_OPTION_TYPES.ADD_QUESTION', pageType: 'add', isAnonymous: true }
  },
  {
    path: 'view/:id',
    loadComponent: () => import('./pages/option-type-questions/option-type-questions.component').then(c => c.OptionTypeQuestionsComponent),
    data: { pageTitle: 'PAGES.FORM_QUESTION_OPTION_TYPES.QUESTIONS_FOR_OPTION_TYPE', pageType: 'view', isAnonymous: true }
  }
];

